import { call, put, takeEvery, all, fork } from 'redux-saga/effects';

import {
  GET_OVERVIEW,
  GET_PROPOSALS_BY_PLANS,
  GET_DEMOGRAPHIC_DATA,
  GET_OVERVIEW_MAPS_DATA,
  GET_OVERVIEW_SALES_FORECAST,
  GET_PROPOSALS_SITUATION,
} from './actionType';

import { OverviewApiResponseSuccess, OverviewApiResponseError } from './action';

import {
  getOverview as overviewGet,
  getDemographicData as demographicDataGet,
  getOverviewProposalsByPlans as overviewProposalsByPlansGet,
  getOverviewMapsData as overviewMapsDataGet,
  getOverviewSalesForecast as overviewSalesForecastGet,
  proposalsSituation,
} from '../../helpers/backend_helper';

function* getOverview(data) {
  try {
    const response = yield call(overviewGet, data.payload.office);
    yield put(OverviewApiResponseSuccess(GET_OVERVIEW, response));
  } catch (error) {
    yield put(OverviewApiResponseError(GET_OVERVIEW, error));
  }
}

function* getOverviewProposalsByPlans(data) {
  try {
    const response = yield call(
      overviewProposalsByPlansGet,
      data.payload.office
    );
    yield put(OverviewApiResponseSuccess(GET_PROPOSALS_BY_PLANS, response));
  } catch (error) {
    yield put(OverviewApiResponseError(GET_PROPOSALS_BY_PLANS, error));
  }
}

function* getDemographicData(data) {
  try {
    const response = yield call(demographicDataGet, data.payload.office);
    yield put(OverviewApiResponseSuccess(GET_DEMOGRAPHIC_DATA, response));
  } catch (error) {
    yield put(OverviewApiResponseError(GET_DEMOGRAPHIC_DATA, error));
  }
}

function* getOverviewMapsData(data) {
  try {
    const response = yield call(overviewMapsDataGet, data.payload.office);
    yield put(OverviewApiResponseSuccess(GET_OVERVIEW_MAPS_DATA, response));
  } catch (error) {
    yield put(OverviewApiResponseError(GET_OVERVIEW_MAPS_DATA, error));
  }
}

function* getOverviewSalesForecast(data) {
  try {
    const response = yield call(overviewSalesForecastGet, data.payload.office);
    yield put(
      OverviewApiResponseSuccess(GET_OVERVIEW_SALES_FORECAST, response)
    );
  } catch (error) {
    yield put(OverviewApiResponseError(GET_OVERVIEW_SALES_FORECAST, error));
  }
}

function* getProposalsBySituation(data) {
  try {
    const response = yield call(proposalsSituation, data.payload);
    yield put(OverviewApiResponseSuccess(GET_PROPOSALS_SITUATION, response));
  } catch (error) {
    yield put(OverviewApiResponseError(GET_PROPOSALS_SITUATION, error));
  }
}

export function* watchGetOverview() {
  yield takeEvery(GET_OVERVIEW, getOverview);
}

export function* watchGetOverviewProposalsByPlans() {
  yield takeEvery(GET_PROPOSALS_BY_PLANS, getOverviewProposalsByPlans);
}

export function* watchGetDemographicData() {
  yield takeEvery(GET_DEMOGRAPHIC_DATA, getDemographicData);
}

export function* watchGetOverviewMapsData() {
  yield takeEvery(GET_OVERVIEW_MAPS_DATA, getOverviewMapsData);
}

export function* watchGetOverviewSalesForecast() {
  yield takeEvery(GET_OVERVIEW_SALES_FORECAST, getOverviewSalesForecast);
}

export function* watchGetProposalsBySituation() {
  yield takeEvery(GET_PROPOSALS_SITUATION, getProposalsBySituation);
}

function* OverviewSaga() {
  yield all([fork(watchGetOverview)]);
  yield all([fork(watchGetDemographicData)]);
  yield all([fork(watchGetOverviewMapsData)]);
  yield all([fork(watchGetOverviewProposalsByPlans)]);
  yield all([fork(watchGetOverviewSalesForecast)]);
  yield all([fork(watchGetProposalsBySituation)]);
}

export default OverviewSaga;
